import { render, staticRenderFns } from "./DashboardDetailFinished1.vue?vue&type=template&id=319c59f5&scoped=true&"
import script from "./DashboardDetailFinished1.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailFinished1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c59f5",
  null
  
)

export default component.exports